import {useSelector} from 'react-redux';

export default (componentId) => {
	const orgStructure = useSelector((store) => store?.project?.orgStructure);
	const componentEngagementId = orgStructure?.find((entity) => entity.entityId === componentId)?.engagements?.[0];

	const engagementMetaData = useSelector(({engagementMetaData}) => engagementMetaData);

	if (!componentId || !componentEngagementId) return null;

	return engagementMetaData?.find((engagementMetadata) => engagementMetadata.id === componentEngagementId);
};
